// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Договори» (Contracts, ключ `contract`, група `office`). */
export const contractsManifest: IModuleManifest = {
  key: 'contract',
  group: 'office',
  slug: 'contracts',
  prefix: 'CTR',
  name: { en: 'Contracts', uk: 'Договори' },
  entities: [
    { key: 'contract', slug: 'contract', name: { en: 'Contracts', uk: 'Договори' }, main: true },
    { key: 'contract_party', slug: 'contract-party', name: { en: 'Contract Parties', uk: 'Сторони' }, main: false },
    { key: 'contract_obligation', slug: 'contract-obligation', name: { en: 'Contract Obligations', uk: 'Зобов’язання' }, main: false },
    { key: 'contract_amendment', slug: 'contract-amendment', name: { en: 'Contract Amendments', uk: 'Поправки' }, main: false },
    { key: 'contract_payment', slug: 'contract-payment', name: { en: 'Contract Payments', uk: 'Платежі' }, main: false },
    { key: 'contract_status', slug: 'contract-status', name: { en: 'Contract Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/contractsSlice').then((m) => m.contractsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
